module.exports = require('./FormMixin');



//////////////////
// WEBPACK FOOTER
// ./~/react-loose-forms/index.js
// module id = 23
// module chunks = 0 1 2 3 4